<div class="kanban-board">
  <app-kanban-filters
    [filters]="boardFilters()"
    [boardFields]="boardFields()"
    [tags]="tags()"
    [phases]="phases()"
    [showAdvancedFilters]="showAdvancedFilters()"
    [userRoleMap]="userRoleMap()"
    (onFiltersChange)="selectedFilters.set($event)"
  ></app-kanban-filters>
  <div class="board-content">
    @if (columns()) {
      <div
        #columnsContainer
        class="columns-container"
        [class.overflowing]="isOverflowing()"
        cdkDropListGroup
      >
        @for (column of visibleColumns(); track column.phaseId) {
          <app-kanban-column
            [phase]="column.phaseId"
            [columnData]="column"
            (cardClick)="onCardClick($event)"
            [actionsConfig]="actionsConfig()?.[column.phaseId]"
            [fieldsToShow]="fieldsToShow()"
            [tagsConfig]="tagsConfig()"
            (openPhaseForm)="onOpenPhaseForm($event)"
            (tagSelected)="onTagSelected($event)"
            (tagRemoved)="onTagRemoved($event)"
          ></app-kanban-column>
        }
      </div>
    } @else if (loading()) {
      <div class="loading-wrapper">
        <visio-loading [type]="'linear'"></visio-loading>
      </div>
    }
  </div>
</div>
<visio-popup id="kanban-popup"></visio-popup>

@if (selectedCard()) {
  <app-card-details-dialog
    [card]="selectedCard()!"
    [showDialog]="showDetailsDialog()"
    [fieldsConfig]="fieldsToShow()"
    (showDialogChange)="onCloseDetailsDialog()"
  ></app-card-details-dialog>
}

@if (boardId() && phaseFormTask() && phaseFormPhaseId()) {
  <app-phase-form
    [boardId]="boardId()!"
    [cardId]="phaseFormTask()!.id"
    [phaseId]="phaseFormPhaseId()!"
    [phaseName]="phaseFormPhaseName()"
    [(isVisible)]="phaseFormIsVisible"
    (onSubmit)="onPhaseFormSubmit()"
  ></app-phase-form>
}
